import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Survey } from '../code/survey';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  private scriptsApi = `${environment.apiPath}/scripts`;

  constructor(private http: HttpClient) {}

  getSurvey$(campaignId: number, version: number) {
    return this.http
      .get<Survey>(
        `${this.scriptsApi}/${campaignId}/survey${
          version > 0 ? `/${version}` : ''
        }`
      )
      .pipe(
        map((survey) => ({
          ...survey,
          drawDate: survey.drawDate ? new Date(survey.drawDate) : undefined,
        }))
      );
  }
}
